import React from 'react'
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import {NavLink} from "react-router-dom";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';


export default function NavigationCardView(props){
    return(
        <Paper sx={{ width: 320, maxWidth: '100%' }}>
            <MenuList>
                <MenuItem component={NavLink} to="/">
                    <ListItemIcon>
                        <HomeOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Feed</ListItemText>
                </MenuItem>
                <MenuItem component={NavLink} to="/circle">
                    <ListItemIcon>
                        <PeopleOutlineOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Circle</ListItemText>
                    <Typography variant="body2" color="text.secondary">
                        {props.connections}
                    </Typography>
                </MenuItem>
                <MenuItem>
                    <ListItemIcon>
                        <MonetizationOnOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Balance</ListItemText>
                    <Typography variant="body2" color="text.secondary">
                        ${props.balance}
                    </Typography>
                </MenuItem>
                <MenuItem component={NavLink} to="/requests">
                    <ListItemIcon>
                        <RequestPageOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Requests</ListItemText>
                    <Typography variant="body2" color="text.secondary">
                        {props.numberRequests}
                    </Typography>
                </MenuItem>
                <MenuItem component={NavLink} to="/proposals">
                    <ListItemIcon>
                        <VolunteerActivismOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Proposals</ListItemText>
                    <Typography variant="body2" color="text.secondary">
                        {props.numberProposals}
                    </Typography>
                </MenuItem>
                <MenuItem component={NavLink} to="/achievement">
                    <ListItemIcon>
                        <EmojiEventsOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Achievements</ListItemText>
                </MenuItem>
                <MenuItem component={NavLink} to="/notifications">
                    <ListItemIcon>
                        <NotificationsNoneOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        Notifications
                    </ListItemText>
                </MenuItem>
                <MenuItem component={NavLink} to="/settings">
                    <ListItemIcon>
                        <SettingsOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Settings</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem component={NavLink} to="/profile">
                    <ListItemIcon>
                        <AccountCircleOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View Profile</ListItemText>
                </MenuItem>
            </MenuList>
        </Paper>
    )
}